export function logoutAccount() {
  return {
    type: 'LOGOUT_ACCOUNT',
  };
}

export function logoutAccountCompletion(error, data) {
  return {
    type: 'LOGOUT_ACCOUNT_COMPLETION',
    error,
    data,
  };
}

export function unbindAccount() {
  return {
    type: 'UNBIND_ACCOUNT',
  };
}

export function unbindAccountCompletion(error, data) {
  return {
    type: 'UNBIND_ACCOUNT_COMPLETION',
    data,
    error,
  };
}

export function syncAccountEditInput(input, reset) {
  return {
    type: 'SYNC_ACCOUNT_EDIT_INPUT',
    input,
    reset,
  };
}

export function syncAccountEditWx(wx) {
  return {
    type: 'SYNC_ACCOUNT_EDIT_WX',
    wx,
  };
}

export function resetPass() {
  return {
    type: 'RESET_PASS',
  };
}

export function resetPassCompletion(error, data) {
  return {
    type: 'RESET_PASS_COMPLETION',
    data,
    error,
  };
}

export function resetMobile() {
  return {
    type: 'RESET_MOBILE',
  };
}

export function resetMobileCompletion(error, data) {
  return {
    type: 'RESET_MOBILE_COMPLETION',
    data,
    error,
  };
}

export function loginAccount() {
  return {
    type: 'LOGIN_ACCOUNT',
  };
}

export function loginAccountCompletion(error, data) {
  return {
    type: 'LOGIN_ACCOUNT_COMPLETION',
    data,
    error,
  };
}

export function bindAccount() {
  return {
    type: 'BIND_ACCOUNT',
  };
}

export function bindAccountCompletion(error, data) {
  return {
    type: 'BIND_ACCOUNT_COMPLETION',
    data,
    error,
  };
}

export function editWechat() {
  return {
    type: 'EDIT_WECHAT',
  };
}

export function editWechatCompletion(error, data) {
  return {
    type: 'EDIT_WECHAT_COMPLETION',
    error,
    data,
  };
}

export function syncWechatEditInput(input, reset) {
  return {
    type: 'SYNC_WECHAT_EDIT_INPUT',
    input,
    reset,
  };
}
